import React, { Component } from "react";
import { withStyles } from '@mui/styles';
import {
  List, 
  ListItem,
  ListItemText,
  ListItemIcon,
  ListItemSecondaryAction,
  Collapse
} from "@mui/material";

import InboxIcon from "@mui/icons-material/Inbox";
import Button from '@mui/material/Button';

import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';
import Alert from '@mui/material/Alert';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import { APIGetpdf } from './Api'
import apiConfig from './config/api'
import { Document, Page } from 'react-pdf';
import FullPagePDFViewer from './FullPagePDFViewer'
import { pdfjs } from 'react-pdf'
// pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.min.js`;
import pdf_config from './configs/pdf_configs'
import {Alerts4} from './Alerts'

// The following lines live together to get Access to the PDFPages class
import {CopyToClipboard} from 'react-copy-to-clipboard';

var  json 
var pdf_pages 
var presenterslides = [];

const console_log = (text) => { 
  return  // Comment out if yoy want logging
  console_log(text)
}
const ColorButton = withStyles((theme) => ({
  root: {
    color: '#ffffff', // theme.palette.getContrastText(lightGreen[50]),
    backgroundColor: '#ff3099',
    '&:hover': {
      backgroundColor: '#ff3099',
    },
  },
}))(Button);

const SmallColorButton = withStyles((theme) => ({
  root: {
    color: '#ffffff', 
    backgroundColor: '#04c659',
    '&:hover': {
      backgroundColor: '#04a659',
    },
    fontSize: '10px',
    paddingTop: '2px',
    paddingBottom: '2px',
    paddingLeft: '5px',
    paddingRight: '5px',
    marginLeft: '5px',
    marginRight: '5px'
  },
}))(Button);


const checkProps =(prop) => {
  return typeof prop !== "undefined" && prop ? true : false
}
class PresenterVersions extends Component {
  constructor(props) {
    super(props);
    this.state = {
        origprops: props,
        saletype: props.saletype,
        items: props.slides,
        pdfpreview: '/live/templates/pdf/',
        pdfpage: 'page1.pdf',
        pageNumber: 1,
        numPages: 1,
        pdffile: '',
        slide_no: '',
        slide_id: '',
        pdf_file_path: '',
        is_loading: false,
        preview_file: '',
        show_preview: false,
        preview_page: 1,
        confirmPreview: false,
        show_alert: false,
        alert_severity: 'info',
        alert_text: '',
        ismounted: false,
        presentation_versions: props.presentation_versions ? props.presentation_versions : [{id: `${props.flg_id}.pdf`, description: 'Default System Proposal'}],
        selected_presentation: checkProps(props.selected_presentation) ? props.selected_presentation : `${props.flg_id}.pdf`,
        copied: [],
    };
  }

  componentDidMount = async () => {
    //console.clear()
    const dt = new Date()
    const create_dt = `${dt.getDate()}/${dt.getMonth()+1}/${dt.getFullYear()} at ${dt.getHours()}:${dt.getMinutes()}:${dt.getSeconds()}`
    
    console_log("#### SlideSetup Component Did Mount ####")
    //console_log("Offerid " + this.props.offerid + ", " + this.props.offertype)
    if(this.state.presentation_versions.length ==0 )
    {
      let versions = []
      versions.push({id: `${this.props.flg_id}.pdf`, description: 'Default System Proposal'})
      this.setState({presentation_versions: versions, create_dt})
    }
  }

  setPage =  async (id) => {
    // const file = path + '/' + page
    const flg_id = this.props.flg_id
    this.setState({is_loading: true})
    let pdf = `${apiConfig.baseUrl}/api/pdf/version/${flg_id}/${encodeURIComponent(id)}`
    //public_url
    //this.setState({pdffile: pdf,  is_loading: true, slide: id,pageNumber: 1, numPages:1  })
 this.setState({pdffile: pdf,  is_loading: true, slide: id})

  }

  onDocumentLoadSuccessPages = ({numPages}) => {
    //console_log("onDocumentLoadSuccessPages")
    //console_log(numPages)

    if(typeof numPages !== "undefined" )
      this.setState({is_loading: false,num_pages: numPages, numPages})
    else  
      this.setState({is_loading: false})
    //this.setState({numPages: event.target.value})
  }
  onDocumentLoadSuccess = (event) => {

    if(typeof event !== "undefined" && typeof event.target !== "undefined")
      this.setState({is_loading: false,num_pages: event, numPages: event})
    else  
      this.setState({is_loading: false})
    //this.setState({numPages: event.target.value})
  }

  // Filter to see if this slide should show up in the deck or not
  

  DoOpenPres = async () => {
    const flg_id = this.props.flg_id
    var output =  pdf_config.dir_path + '/' + flg_id + '/pdf/' + flg_id + '.pdf'
    //var output =  '/presenter/documents/customers/' + flg_id + '/pdf/' + flg_id + '.pdf'
    console_log("Get PDF " + output)
    var preview = await APIGetpdf(output)
    preview = `${apiConfig.baseUrl}/api/pdf/presentation/${flg_id}`
    this.setState({preview_file: preview, show_preview: true,confirmPreview: this.state.preview_page > 1 ? true: false,})
  } 

  handlePreview = (events ) => {
    if(events)
      this.setState({confirmPreview: false})
    else
      this.setState({confirmPreview: false, preview_page: 1})
  }  

  ClosePreview = () => { 
    this.setState({show_preview: false})
  }
  updatePage = (page) => {
    this.setState({preview_page: page})
  }

  changePage = (offset) => {
    this.setState({pageNumber: this.state.pageNumber + offset})
  }
  selectPage = (event) => {
    this.setState({pageNumber: event.target.value})    
  }

 previousPage = () => {
    this.changePage(-1);
  }

  nextPage = () => {
    this.changePage(1);
  }

  getDeckType = (decktype_in) => {
    var  decktype 
    switch(decktype_in) {
        case "fld":
          decktype = "Full"
          break
        case 'mnd':
          decktype = "Mandatory"
          break
        case 'fnd':
          decktype = "Finance"
          break
        default:
          decktype = "Unknown"
          break
    }
    return decktype;
  }
copyURL = (index) =>{
  let copied = this.state.copied;
  copied[index] = true;
  this.setState({copied})
}
  // Normally you would want to split things out into separate components.
  // But in this example everything is just done in one place for simplicity
    render() {
        const url =this.state.pdfpreview + '/' + this.state.pdfpage
        const { classes } = this.props;
        const ismounted = this.state.ismounted
        const { pdffile, slide_no, pageNumber, numPages } = this.state
        const pv = this.state.presentation_versions
        let pages = []
        for(let i=1; i<=numPages; i++) pages.push({text: `Page ${i}`, pageNumber: i})

        if( this.state.confirmPreview ) {
        return (
            <Alerts4
            open={this.state.confirmPreview} onClose={this.handlePreview } preview_page = {this.state.preview_page}
            />
        )
        }
        if(this.state.show_preview) {
        return (<>
        <Backdrop className={classes.fullscreen} open={this.state.show_preview} >
            <FullPagePDFViewer file={this.state.preview_file} preview_page={this.state.preview_page} onChange={this.updatePage} ClosePreview={this.ClosePreview} />
        </Backdrop>
        </>
        )
        }
        return(
            <div className={classes.mainDiv} style={{display: 'inline-block', textAlign: 'start'}} >
                <Collapse in={this.state.show_alert}> 
                    <Alert
                        variant='outlined'
                        style={{width: '800px', alignItems: 'center', textAlign: 'top', marginTop: '10px'}} 
                        severity={this.state.alert_severity}          
                        action={
                            <IconButton
                            aria-label="close"
                            color="inherit"
                            size="small"
                            onClick={() => {
                                this.setState({show_alert: false})
                            }}
                            >
                            <CloseIcon fontSize="inherit" />
                            </IconButton > 
                        } >
                        {this.state.alert_text}
                    </Alert>
                </Collapse> 
                        
                <div style={{overflow: 'auto', height: '600px', width: '400px', margin_bottom: '10px', left: 0, position: 'absolute'}} >
                    <List >
                        {pv.length > 0 && pv.map((item, index) => {return(
                            <ListItem
                                divider={true}
                                ContainerComponent="li"
                                key={index}
                            >
                            <ListItemIcon >
                                <InboxIcon onClick={(event) => this.setPage(item.id)}/>
                            </ListItemIcon>
                            <ListItemText
                                primary={item.primary}
                                secondary={item.secondary}
                            >
                                <div style={{textAlign: 'left', fontSize: '12px', display: 'inline-block'}} >
                                    Deck Type: {this.getDeckType(item.current_decktype)}<br/>
                                    Description: {item.description}<br/>
                                    ID: {item.id}<br/>
                                    Created At: {item.create_dt}<br/>
                                    <CopyToClipboard text={`${apiConfig.baseUrl}/api/pdf/version/${this.props.flg_id}/${encodeURIComponent(item.id)}`}
                                    onCopy={() => this.copyURL(index)}>
                                    <SmallColorButton >{this.state.copied[index] ? 'URL Copied' : 'Copy URL'}</SmallColorButton>
                                    </CopyToClipboard>&nbsp;<br/>
 
                                </div>
                            </ListItemText>
                            </ListItem>
                        )})
                    }
                    </List>
                </div>
                <div style={{top: 0, left: 405, position: "absolute"}} >
                    <Backdrop className={classes.backdrop} open={this.state.is_loading} >
                        <CircularProgress color="secondary" size={150}/>
                    </Backdrop>
                    <div style={{fontSize: '20pt'}} >Presentation {this.state.slide}</div>
                    <Document
                        loading="Please wait whilst the slide loads..."
                        file={pdffile}
                        onLoadError={this.onDocumentLoadSuccess}
                        onLoadSuccess={this.onDocumentLoadSuccessPages}
                    >
                    <Page pageNumber={pageNumber} 
                        scale={0.5}
                        loading="Please wait whilst the presentation slide loads..."
                        className={classes.document}
                        onRenderSuccess={this.onDocumentLoadSuccess}
                        onLoadError={this.onDocumentLoadSuccess}
                    />
                    </Document> 
                    {numPages > 0 &&
                    <div>
                        <p>PAGE {pageNumber || (numPages ? 1 : "--")} of {numPages || "--"}</p>
                        <button type="button" disabled={pageNumber <= 1} onClick={this.previousPage}>Previous</button>
                        <button
                        type="button"
                        disabled={pageNumber >= numPages}
                        onClick={this.nextPage}
                        >Next</button>&nbsp;
                        <>
                        <Select
                          value={pageNumber}
                          onChange={this.selectPage} 
                          style={{fontSize: '12px'}}
                        >
                          {pages.map((item, index) => {return (
                            <MenuItem key={index} value={item.pageNumber} style={{fontSize: '12px'}} >{item.text} </MenuItem> )
                          })} 
                        </Select>
                        </>
                    </div>
                    }
                </div>
            </div>
        )
    }
}

const styles = theme => ({
  document: {
    position: 'absolute',
    border: '1px solid #ff3099',
  },
  backdrop: {
      position: 'absolute',
      top: 0,
      left: 0,
      zIndex: 1000,
      width: '100%',
      height: '100%'
  },
  buttonspace: {
    marginRight: '10px'
  },
  fullscreen: {
    backgroundColor: "#fff",
    position: 'fixed',
    zIndex: 1000,
    top: 0,
    left: 0,
    width: '100%',
    height: '100%'
  },
  version_descriptions: {
    fontSize: '12px',
    width: '50%',
    maxWidth: '450px',
  },
  version_input: {
    fontSize: '12px',
    width: '250px',
    maxWidth: '250px',
  },
  versionBox: {
    width: '80%', 
    maxWidth: '800px',
    paddingTop: '3px',
    paddingBottom: '3px',
    paddingLeft: '5px',
    paddingRight: '5px',
    marginTop: '5px',
    display: "flex",
    alignItems: "center"
  },
  mainDiv: {
    position: 'relative', 
    height: '600px', 
    width: '1280px ',
  }
});

export default withStyles(styles)(PresenterVersions)
